
<script>
import axios from 'axios'

export default {
  name: 'about',
  data: () => ({
    users: []
  }),
  mounted() {
    /* eslint-disable */
    document.addEventListener('render-done', (e) => {
      console.log(e)
    })
    const url = 'https://jsonplaceholder.typicode.com/users'
    axios.get(url).then((res) => {
      this.users = res.data
      console.log(this.users)
      this.$nextTick(() => {
        const event = new CustomEvent('render-done')
        document.dispatchEvent(event)
      })
    })
    /* eslint-enable */
  }
}
</script>

<template>
  <div>
    <h1>Lorem, ipsum dolor.</h1>
    <p
      v-for="user in users"
      :key="user.id"
    >
      {{ user.name }}
    </p>
    <div id="pre-content" />
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque quod, temporibus laudantium
      perferendis consequatur maiores at cupiditate repellat cumque, accusamus repellendus eveniet
      aliquam quam voluptas unde laboriosam amet, sed vel.Corrupti cumque architecto minima vero
      amet dolorum optio iste provident dolorem perferendis id saepe, ab unde quod hic est. Animi ea
      minima distinctio pariatur impedit consectetur nesciunt tempore ratione voluptates?
    </p>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque quod, temporibus laudantium
      perferendis consequatur maiores at cupiditate repellat cumque, accusamus repellendus eveniet
      aliquam quam voluptas unde laboriosam amet, sed vel.Corrupti cumque architecto minima vero
      amet dolorum optio iste provident dolorem perferendis id saepe, ab unde quod hic est. Animi ea
      minima distinctio pariatur impedit consectetur nesciunt tempore ratione voluptates?
    </p>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque quod, temporibus laudantium
      perferendis consequatur maiores at cupiditate repellat cumque, accusamus repellendus eveniet
      aliquam quam voluptas unde laboriosam amet, sed vel.Corrupti cumque architecto minima vero
      amet dolorum optio iste provident dolorem perferendis id saepe, ab unde quod hic est. Animi ea
      minima distinctio pariatur impedit consectetur nesciunt tempore ratione voluptates?
    </p>
  </div>
</template>
